
//const serverUrl = "http://192.168.0.27:8484/questSearch-Server-main/public/index.php/";
const serverUrl = "https://questquote.com/qqnserver/public/index.php/";

export const fetchOpenRequest = async (
  url,
  body = {},
  header = {},
  files = [],
  method = "POST"
) => {
  try {
    var formData = new FormData();
    if (body != null) {
      if (Object.keys(body).length > 0) {
        for (var key in body) {
          if (Array.isArray(body[key])) {
            for (var akey in body[key]) {
              if (Object.keys(body[key][akey]).length > 0) {
                for (var bkey in body[key][akey]) {
                  formData.append(
                    key + "[" + akey + "][" + bkey + "]",
                    body[key][akey][bkey]
                  );
                }
              } else {
                formData.append(key + "[" + akey + "]", body[key][akey]);
              }
            }
          } else {
            formData.append(key, body[key]);
          }
        }
      }
    }

    if (files != null) {
      if (files.length > 0) {
        for (var keyA in files) {
          formData.append(files[keyA].name, files[keyA]);
        }
      }
    }

    let defaultHeader = {};
    if (header != null) {
      if (Object.keys(header).length > 0) {
        defaultHeader = { ...defaultHeader, ...header };
      }
    }

    let response = fetch(
      `${serverUrl}${url}`,
      method === "POST"
        ? {
            method: method,
            headers: defaultHeader,
            body: body != null && Object.keys(body).length > 0 ? formData : {},
          }
        : { method: method, headers: defaultHeader }
    );

    return response;
  } catch (err) {
    console.log(err.message);
  }
};

export const fetchOtherRequest = async (
  url,
  body = [],
  header = [],
  files = [],
  method = "POST"
) => {
  let formData = new FormData();
  for (var key in body) {
    if (Array.isArray(body[key])) {
      for (var akey in body[key]) {
        formData.append(key + "[" + akey + "]", body[key][akey]);
      }
    } else {
      formData.append(key, body[key]);
    }
  }

  if (files.length > 0) {
    for (var keyA in files) {
      formData.append(files[keyA].name, files[keyA]);
    }
  }
  let response = await fetch(
    url,
    method === "POST"
      ? {
          method: method,
          headers: header,
          body: formData,
        }
      : { method: method, headers: header }
  );
  return response;
};
